module.exports = __webpack_public_path__ + "static/honolulu-05f2d94779f3f7626f29b6a27fceefc6.png";